import { defineComponent, computed } from '@vue/composition-api';
import { useTabsContext } from './SdsTabsContext.js';

var script = defineComponent({
    name: 'SdsTabPanel',
    props: {
        value: {
            type: String,
            required: true,
        },
        tag: {
            type: String,
            required: false,
            default: 'div',
        }
    },
    setup: function (props) {
        var activeValue = useTabsContext().value;
        return {
            isShown: computed(function () { return activeValue.value === props.value; }),
        };
    },
});

export default script;
